class LimitTextarea {
	constructor(element) {
		this.textareaContainer = element;
		this.textarea = this.textareaContainer.querySelector('textarea');
		this.textareaLimit = +this.textarea.dataset.limit;
		this.maxLengthElement = this.textareaContainer.querySelector('.js-textarea-limit-length');
		this._init();
	}

	_init = () => {
		if (this.textareaContainer.classList.contains('init')) return;

		this.textarea.addEventListener('input', this._textareaHandler);
		this.textareaContainer.classList.add('init');
	}

	_textareaHandler = (e) => {
		const currentLength = e.currentTarget.value.length;

		if (currentLength >= this.textareaLimit) {
			this.textarea.value = this.textarea.value.slice(0, this.textareaLimit);
		}

		this._renderMaxLength();
	}

	_renderMaxLength() {
		this.maxLengthElement.textContent = `${this.textareaLimit - this.textarea.value.length}`;
	}
}
